export const cards = [
    { power: 2, type: 'diamonds' },
    { power: 3, type: 'diamonds' },
    { power: 4, type: 'diamonds' },
    { power: 5, type: 'diamonds' },
    { power: 6, type: 'diamonds' },
    { power: 7, type: 'diamonds' },
    { power: 8, type: 'diamonds' },
    { power: 9, type: 'diamonds' },
    { power: 10, type: 'diamonds' },
    { power: 11, type: 'diamonds' },
    { power: 12, type: 'diamonds' },
    { power: 13, type: 'diamonds' },
    { power: 14, type: 'diamonds' },
    { power: 2, type: 'pika' },
    { power: 3, type: 'pika' },
    { power: 4, type: 'pika' },
    { power: 5, type: 'pika' },
    { power: 6, type: 'pika' },
    { power: 7, type: 'pika' },
    { power: 8, type: 'pika' },
    { power: 9, type: 'pika' },
    { power: 10, type: 'pika' },
    { power: 11, type: 'pika' },
    { power: 12, type: 'pika' },
    { power: 13, type: 'pika' },
    { power: 14, type: 'pika' },
    { power: 2, type: 'cross' },
    { power: 3, type: 'cross' },
    { power: 4, type: 'cross' },
    { power: 5, type: 'cross' },
    { power: 6, type: 'cross' },
    { power: 7, type: 'cross' },
    { power: 8, type: 'cross' },
    { power: 9, type: 'cross' },
    { power: 10, type: 'cross' },
    { power: 11, type: 'cross' },
    { power: 12, type: 'cross' },
    { power: 13, type: 'cross' },
    { power: 14, type: 'cross' },
    { power: 2, type: 'byb' },
    { power: 3, type: 'byb' },
    { power: 4, type: 'byb' },
    { power: 5, type: 'byb' },
    { power: 6, type: 'byb' },
    { power: 7, type: 'byb' },
    { power: 8, type: 'byb' },
    { power: 9, type: 'byb' },
    { power: 10, type: 'byb' },
    { power: 11, type: 'byb' },
    { power: 12, type: 'byb' },
    { power: 13, type: 'byb' },
    { power: 14, type: 'byb' },

]